export const priceFromAPI = (amount) => {
  return !isNaN(amount)
    ? Number((amount || 0) / 100).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : '0.00';
};
export const priceForAPI = (amount) => {
  return /[^0-9.]+/g.test(amount)
    ? Number(`${amount || 0}`.replace(/[^0-9]+/g, ''))
    : Number(amount || 0).toFixed(2) * 100;
};

export const priceToDisplay = (amount) => {
  const n = /[^0-9.]+/g.test(amount)
    ? Number(`${amount || 0}`.replace(/[^0-9]+/g, ''))
    : Number((amount || 0) * 100).toFixed(2);

  return priceFromAPI(n);
};
